export const setEmailUsuario = emailUsuario => localStorage.setItem('emailUsuario', emailUsuario)
export const deleteEmailUsuario = () => localStorage.removeItem('emailUsuario')
export const getEmailUsuario = () => localStorage.getItem('emailUsuario')

export const setNomeEmpresa = nomeEmpresa => localStorage.setItem('nomeEmpresa', nomeEmpresa)
export const deleteNomeEmpresa = () => localStorage.removeItem('nomeEmpresa')
export const getNomeEmpresa = () => localStorage.getItem('nomeEmpresa')

export const setIdEmpresa = nomeEmpresa => localStorage.setItem('idEmpresa', nomeEmpresa)
export const deleteIdEmpresa = () => localStorage.removeItem('idEmpresa')
export const getIdEmpresa = () => localStorage.getItem('idEmpresa')

export const setCpfCnpj = cpfCnpj => localStorage.setItem('cpfCnpj', cpfCnpj)
export const deleteCpfCnpj = () => localStorage.removeItem('cpfCnpj')
export const getCpfCnpj = () => localStorage.getItem('cpfCnpj')

export const setRepresentanteLegal = representanteLegal => localStorage.setItem('representanteLegal', representanteLegal)
export const deleteRepresentanteLegal = () => localStorage.removeItem('representanteLegal')
export const getRepresentanteLegal = () => localStorage.getItem('representanteLegal')

export const setRegrasLogin = regrasLogin => localStorage.setItem('regrasLogin', regrasLogin)
export const deleteRegrasLogin = () => localStorage.removeItem('regrasLogin')
export const getRegrasLogin = () => localStorage.getItem('regrasLogin')

export const setLoginStrategy = loginStrategy => localStorage.setItem('loginStrategy', loginStrategy)
export const deleteLoginStrategy = () => localStorage.removeItem('loginStrategy')
export const getLoginStrategy = () => localStorage.getItem('loginStrategy')

export const setLogoCliente = logoCliente => localStorage.setItem('logoCliente', logoCliente)
export const deleteLogoCliente = () => localStorage.removeItem('logoCliente')
export const getLogoCliente = () => localStorage.getItem('logoCliente')

export const setEscritorio = escritorio => localStorage.setItem('escritorio', escritorio)
export const deleteEscritorio = () => localStorage.removeItem('escritorio')
export const getEscritorio = () => localStorage.getItem('escritorio')

export const setTipoDeAcesso = tipoDeAcesso => localStorage.setItem('tipoDeAcesso', tipoDeAcesso)
export const deleteTipoDeAcesso = () => localStorage.removeItem('tipoDeAcesso')
export const getTipoDeAcesso = () => localStorage.getItem('tipoDeAcesso')

export const setFaturamentoContratado = faturamentoContratado => localStorage.setItem('faturamentoContratado', faturamentoContratado)
export const deleteFaturamentoContratado = () => localStorage.removeItem('faturamentoContratado')
export const getFaturamentoContratado = () => localStorage.getItem('faturamentoContratado')

export const setTemAcessoAoFaturamento = temAcessoAoFaturamento => localStorage.setItem('temAcessoAoFaturamento', temAcessoAoFaturamento)
export const deleteTemAcessoAoFaturamento = () => localStorage.removeItem('temAcessoAoFaturamento')
export const getTemAcessoAoFaturamento = () => localStorage.getItem('temAcessoAoFaturamento')

export const setFinanceiroContratado = financeiroContratado => localStorage.setItem('financeiroContratado', financeiroContratado)
export const deleteFinanceiroContratado = () => localStorage.removeItem('financeiroContratado')
export const getFinanceiroContratado = () => localStorage.getItem('financeiroContratado')

export const setTemAcessoAoFinanceiro = temAcessoAoFinanceiro => localStorage.setItem('temAcessoAoFinanceiro', temAcessoAoFinanceiro)
export const deleteTemAcessoAoFinanceiro = () => localStorage.removeItem('temAcessoAoFinanceiro')
export const getTemAcessoAoFinanceiro = () => localStorage.getItem('temAcessoAoFinanceiro')

export const setTemAcessoAosRelatorios = temAcessoAosRelatorios => localStorage.setItem('temAcessoAosRelatorios', temAcessoAosRelatorios)
export const deleteTemAcessoAosRelatorios = () => localStorage.removeItem('temAcessoAosRelatorios')
export const getTemAcessoAosRelatorios = () => localStorage.getItem('temAcessoAosRelatorios')

export const setRelatoriosContratado = relatoriosContratado => localStorage.setItem('relatoriosContratado', relatoriosContratado)
export const deleteRelatoriosContratado = () => localStorage.removeItem('relatoriosContratado')
export const getRelatoriosContratado = () => localStorage.getItem('relatoriosContratado')

export const setTemAcessoAoEscritorio = temAcessoAoEscritorio => localStorage.setItem('temAcessoAoEscritorio', temAcessoAoEscritorio)
export const deleteTemAcessoAoEscritorio = () => localStorage.removeItem('temAcessoAoEscritorio')
export const getTemAcessoAoEscritorio = () => localStorage.getItem('temAcessoAoEscritorio')

export const setNomeUsuarioLogado = nomeUsuarioLogado => localStorage.setItem('nomeUsuarioLogado', nomeUsuarioLogado)
export const deleteNomeUsuarioLogado = () => localStorage.removeItem('nomeUsuarioLogado')
export const getNomeUsuarioLogado = () => localStorage.getItem('nomeUsuarioLogado')

export const setCodigoFotoUsuario = codigoFotoUsuario => localStorage.setItem('codigoFotoUsuario', codigoFotoUsuario)
export const deleteCodigoFotoUsuario = () => localStorage.removeItem('codigoFotoUsuario')
export const getCodigoFotoUsuario = () => localStorage.getItem('codigoFotoUsuario')

export const setPerfilUsuario = perfilUsuario => localStorage.setItem('perfilUsuario', perfilUsuario)
export const deletePerfilUsuario = () => localStorage.removeItem('perfilUsuario')
export const getPerfilUsuario = () => localStorage.getItem('perfilUsuario')

export const setDataRefreshPagina = dataRefreshPagina => localStorage.setItem('dataRefreshPagina', dataRefreshPagina)
export const getDataRefreshPagina = () => localStorage.getItem('dataRefreshPagina')

export const setEscritorioInadimplente = escritorioInadimplente => localStorage.setItem('escritorioInadimplente', escritorioInadimplente)
export const deleteEscritorioInadimplente = () => localStorage.removeItem('escritorioInadimplente')
export const getEscritorioInadimplente = () => localStorage.getItem('escritorioInadimplente')

export const setDadosAlertaVencimento = dadosAlertaVencimento => localStorage.setItem('dadosAlertaVencimento', dadosAlertaVencimento)
export const deleteDadosAlertaVencimento = () => localStorage.removeItem('dadosAlertaVencimento')
export const getDadosAlertaVencimento = () => localStorage.getItem('dadosAlertaVencimento')

export const setIdUsuarioLogado = idUsuarioLogado => localStorage.setItem('idUsuarioLogado', idUsuarioLogado)
export const deleteIdUsuarioLogado = () => localStorage.removeItem('idUsuarioLogado')
export const getIdUsuarioLogado = () => localStorage.getItem('idUsuarioLogado')

export const setDataCriacaoUsuarioLogado = dataCriacaoUsuarioLogado => localStorage.setItem('dataCriacaoUsuarioLogado', dataCriacaoUsuarioLogado)
export const deleteDataCriacaoUsuarioLogado = () => localStorage.removeItem('dataCriacaoUsuarioLogado')
export const getDataCriacaoUsuarioLogado = () => localStorage.getItem('dataCriacaoUsuarioLogado')

export const setSuporteOnlineHabilitado = suporteOnlineHabilitado => localStorage.setItem('suporteOnlineHabilitado', suporteOnlineHabilitado)
export const deleteSuporteOnlineHabilitado = () => localStorage.removeItem('suporteOnlineHabilitado')
export const getSuporteOnlineHabilitado = () => localStorage.getItem('suporteOnlineHabilitado')

export const setOcultarOpcaoMenuBanco = ocultarOpcaoMenuBanco => localStorage.setItem('ocultarOpcaoMenuBanco', ocultarOpcaoMenuBanco)
export const deleteOcultarOpcaoMenuBanco = () => localStorage.removeItem('ocultarOpcaoMenuBanco')
export const getOcultarOpcaoMenuBanco = () => localStorage.getItem('ocultarOpcaoMenuBanco')

export const setAlertaStatusEmpresa = alertaStatusEmpresa => localStorage.setItem('alertaStatusEmpresa', alertaStatusEmpresa)
export const deleteAlertaStatusEmpresa = () => localStorage.removeItem('alertaStatusEmpresa')
export const getAlertaStatusEmpresa = () => localStorage.getItem('alertaStatusEmpresa')
